// extracted by mini-css-extract-plugin
var _1 = "KqwrR";
var _2 = "aJAkV";
var _3 = "Yh6Aw";
var _4 = "J6KkU";
var _5 = "TEFxS";
var _6 = "a44vi";
var _7 = "I98Oo";
var _8 = "vB3WV";
export { _1 as "base", _2 as "bottom", _3 as "cell", _4 as "header", _5 as "left", _6 as "right", _7 as "selected", _8 as "top" }
